import { ButtonHTMLAttributes, FC, memo, MouseEvent } from 'react';

import Icon from '../Icon';

import s from './Modal.module.scss';

interface Props {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

type NativeAttrs = Omit<ButtonHTMLAttributes<HTMLButtonElement>, keyof Props>;

export type ModalCloseButtonProps = Props & NativeAttrs;

const ModalCloseButton: FC<React.PropsWithChildren<React.PropsWithChildren<ModalCloseButtonProps>>> = ({ onClick, ...props }) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button type="button" onClick={handleClick} className={s.dialog__close__button} aria-label="Close" {...props}>
      <Icon type="close" size={24} />
    </button>
  );
};

const MemoModalCloseButton = memo(ModalCloseButton);
export default MemoModalCloseButton;
